import React from 'react';
import { Container, H5 } from '@ui';
import styled from 'styled-components';
import { selectDarkTheme } from '@utils/themes';
import { PersonProfile, PersonProfileGrid } from '@ui/PersonProfile';

const Wrapper = styled.div`
  padding: 24px 60px 80px 60px;
  max-width: 1340px;

  * {
    color: ${({ theme }) => selectDarkTheme(theme).text};
  }
`;

export const Founders = () => {
  const ratio = 567 / 376;
  return (
    <Wrapper>
      <Container bottom={60}>
        <H5>TEAM & LEADERSHIP</H5>
      </Container>
      <PersonProfileGrid>
        <PersonProfile
          imgSrc={'/images/profiles/bernard.png'}
          name={'Bernard George'}
          title={'CEO'}
          linkedInUrl={'https://www.linkedin.com/in/bernardgeorge-nvstr/'}
          ratio={ratio}
        >
          <ul>
            <li>Previously Portfolio Manager/Trader at JP Morgan, Credit Suisse, C12 Capital</li>
            <li>2-time US Physics Olympiad team member</li>
            <li>AB in Physics, Harvard University</li>
          </ul>
        </PersonProfile>
        <PersonProfile
          imgSrc={'/images/profiles/patrick.png'}
          name={'Patrick Aber'}
          title={'COO'}
          linkedInUrl={'https://www.linkedin.com/in/patrickaber/'}
          ratio={ratio}
        >
          <ul>
            <li>Previously Portfolio Manager/Trader at Tower Research Capital and The Carlyle Group</li>
            <li>AB in Applied Math, Harvard University</li>
          </ul>
        </PersonProfile>
      </PersonProfileGrid>
    </Wrapper>
  );
};
